import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { fetchStages } from './actions';

const stageAdapter = createEntityAdapter({
    selectId: (stage) => stage.id,
    sortComparer: false,
});

const initialState = stageAdapter.getInitialState();

const stageSlice = createSlice({
    name: 'stage',
    initialState,
    reducers: {
        addStages: stageAdapter.addMany,
        updateOne: stageAdapter.updateOne,
        updateMany: stageAdapter.updateMany,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchStages.fulfilled, (state, action) => {
            stageAdapter.addMany(state, action.payload);
        });
    },
});

export const stageSelector = stageAdapter.getSelectors((state) => state.stageReducer);
export const { actions } = stageSlice;
export const { reducer: stageReducer } = stageSlice;
